import Cookies from 'js-cookie'
import { encryptString,decodeString } from "@/utils/base64"
import { isJson } from "@/utils"

// 存
export function CookieSet(key,value){

    if(isJson(value)) value = JSON.stringify(value)

    return Cookies.set(key,encryptString(value))
}

// 取
export function CookieGet(key){
    if(!Cookies.get(key)) return Cookies.get(key)
    let value = decodeString(Cookies.get(key))
    try {
        return JSON.parse(value)
    } catch (error) {
        return value
    }
}

// 删
export function CookieRemove(key){
    Cookies.remove(key)
}